<!-- https://www.smashingmagazine.com/2014/05/responsive-images-done-right-guide-picture-srcset/ -->
<template>
  <div
    v-if="picture"
    class="picture"
  >
    <picture>
      <source
        :srcset="srcset"
        :sizes="sizes"
        :media="media"
      />
      <img
        ref="image"
        class="picture__img"
        :src="origin"
        :alt="alt"
        :width="width"
        :height="height"
        :loading="loading"
        :decoding="decoding"
        @load="onLoaded"
      />
    </picture>
    <client-only>
      <LazyloadPlaceholder
        v-if="!loaded"
        class="picture__placeholder"
      />
    </client-only>
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import type { TImageOriginFull } from '~/types/common';
  import LazyloadPlaceholder from './LazyloadPlaceholder.vue';

  export default defineNuxtComponent({
    name: 'AdaptivePicture',

    components: {
      LazyloadPlaceholder,
    },

    props: {
      picture: {
        type: Object as PropType<TImageOriginFull | null>,
        required: true,
      },

      srcset: {
        type: String as PropType<string | null>,
        default: null,
      },

      sizes: {
        type: String as PropType<string | null>,
        default: null,
      },

      media: {
        type: String as PropType<string | null>,
        default: null,
      },

      width: {
        type: Number as PropType<number>,
        default: 0,
      },

      height: {
        type: Number as PropType<number>,
        default: 0,
      },

      loading: {
        type: String as PropType<'lazy' | 'eager' | 'auto'>,
        default: 'lazy',
      },

      decoding: {
        type: String as PropType<string>,
        default: 'async',
      },
    },

    data: () => ({
      loaded: false,
    }),

    computed: {
      alt(): string {
        return this.picture?.alt || 'Изображение';
      },

      origin(): string {
        return this.picture?.origin.url || '';
      },
    },

    mounted() {
      const image = this.$refs.image as HTMLImageElement;
      this.loaded = !!(image.complete && image.naturalHeight);
    },

    methods: {
      onLoaded(): void {
        this.$emit('loaded');
        this.loaded = true;
      },
    },
  });
</script>

<style lang="scss" scoped>
  .picture {
    display: block;
    width: 100%;
    height: 100%;
    position: relative;

    &__img {
      display: block;
      width: 100%;
      max-width: 100%;
      height: auto;

      &--noscript {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        width: 100%;
        height: 100%;
      }
    }

    &__placeholder {
      position: absolute;
      z-index: 1;
      top: 0;
      left: 0;
    }
  }
</style>
